/**
 * Generated by scripts/generate-drizzle-schema.mjs. Do not edit by hand.
 * This product's inputs: scripts/drizzle-schema.config.mjs.
 * Regenerate: bash scripts/client-schema-fresh.sh (data-model-change skill).
 */

import { DrizzleAppSchema, type PowerSyncSQLiteDatabase } from "@powersync/drizzle-driver";
import { index, integer, sqliteTable, text } from "drizzle-orm/sqlite-core";
import type { InferInsertModel, InferSelectModel } from "drizzle-orm";

export const attachment = sqliteTable(
  "attachment",
  {
    id: text("id").primaryKey(),
    todo_id: text("todo_id"),
    filename: text("filename"),
    content_type: text("content_type"),
    size: integer("size"),
    url: text("url"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    list_id: text("list_id"),
    user_id: text("user_id"),
    is_shared: integer("is_shared"),
    hash: text("hash"),
    page_id: text("page_id"),
  },
  (table) => [
    /** WHERE user_id = ? in getHasLocalDataQuery */
    index("attachment_by_user").on(table.user_id),
    /** WHERE page_id = ? ORDER BY created_at in usePageAttachments */
    index("attachment_by_page").on(table.page_id, table.created_at),
  ],
);

// Content blocks (Folio) — grows with every page, critical indexes.
export const block = sqliteTable(
  "block",
  {
    id: text("id").primaryKey(),
    page_id: text("page_id"),
    user_id: text("user_id"),
    type: text("type"),
    content: text("content"),
    sort_key: text("sort_key"),
    is_shared: integer("is_shared"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    text: text("text"),
  },
  (table) => [
    /** WHERE page_id = ? ORDER BY sort_key in usePageBlocks() */
    index("block_by_page").on(table.page_id, table.sort_key),
    /** WHERE user_id = ? in getHasLocalDataQuery */
    index("block_by_user").on(table.user_id),
  ],
);

export const font_family = sqliteTable("font_family", {
  id: text("id").primaryKey(),
  family: text("family"),
  name: text("name"),
  category: text("category"),
  is_active: integer("is_active"),
  sort_order: integer("sort_order"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
});

export const font_variant = sqliteTable("font_variant", {
  id: text("id").primaryKey(),
  font_family_id: text("font_family_id"),
  weight: text("weight"),
  url: text("url"),
  created_at: text("created_at"),
  attachment_id: text("attachment_id"),
});

// Small dataset per user — indexes not needed for now.
export const member = sqliteTable("member", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  user_id: text("user_id"),
  role: text("role"),
  created_at: text("created_at"),
});

// Small dataset — indexes not needed for now.
export const organization = sqliteTable("organization", {
  id: text("id").primaryKey(),
  name: text("name"),
  slug: text("slug"),
  logo: text("logo"),
  metadata: text("metadata"),
  created_at: text("created_at"),
});

// Hierarchical pages (Folio) with index by user and by parent.
export const page = sqliteTable(
  "page",
  {
    id: text("id").primaryKey(),
    user_id: text("user_id"),
    title: text("title"),
    icon: text("icon"),
    parent_page_id: text("parent_page_id"),
    sort_key: text("sort_key"),
    is_shared: integer("is_shared"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
    restored_from_version: text("restored_from_version"),
  },
  (table) => [
    /** WHERE user_id = ? in usePages and getHasLocalDataQuery */
    index("page_by_user").on(table.user_id),
    /** WHERE parent_page_id = ? ORDER BY sort_key in page tree */
    index("page_by_parent").on(table.parent_page_id, table.sort_key),
  ],
);

// Dataset managed by sync streams — indexes not needed for now.
export const page_organization = sqliteTable("page_organization", {
  id: text("id").primaryKey(),
  page_id: text("page_id"),
  organization_id: text("organization_id"),
  added_at: text("added_at"),
  added_by: text("added_by"),
});

export const page_version = sqliteTable("page_version", {
  id: text("id").primaryKey(),
  user_id: text("user_id"),
  page_id: text("page_id"),
  title: text("title"),
  icon: text("icon"),
  blocks: text("blocks"),
  text: text("text"),
  client_ts: text("client_ts"),
  server_ts: text("server_ts"),
});

// Active user sessions — small dataset, no indexes.
export const session = sqliteTable("session", {
  id: text("id").primaryKey(),
});

// Small global dataset (~20 themes) — indexes not needed.
export const themes = sqliteTable("themes", {
  id: text("id").primaryKey(),
  name: text("name"),
  background: text("background"),
  surface: text("surface"),
  accent: text("accent"),
  glow_colors: text("glow_colors"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  is_dark: integer("is_dark"),
  foreground: text("foreground"),
  field_background: text("field_background"),
  danger: text("danger"),
  success: text("success"),
  warning: text("warning"),
  muted: text("muted"),
  pattern_type: text("pattern_type"),
  pattern_opacity: integer("pattern_opacity"),
  pair_id: text("pair_id"),
  font_normal: text("font_normal"),
  font_medium: text("font_medium"),
  font_semibold: text("font_semibold"),
  font_bold: text("font_bold"),
  radius: text("radius"),
  surface_foreground: text("surface_foreground"),
  surface_secondary: text("surface_secondary"),
  surface_secondary_foreground: text("surface_secondary_foreground"),
  surface_tertiary: text("surface_tertiary"),
  surface_tertiary_foreground: text("surface_tertiary_foreground"),
  overlay: text("overlay"),
  overlay_foreground: text("overlay_foreground"),
  default: text("default"),
  default_foreground: text("default_foreground"),
  accent_foreground: text("accent_foreground"),
  field_foreground: text("field_foreground"),
  field_placeholder: text("field_placeholder"),
  field_border: text("field_border"),
  danger_foreground: text("danger_foreground"),
  success_foreground: text("success_foreground"),
  warning_foreground: text("warning_foreground"),
  segment: text("segment"),
  segment_foreground: text("segment_foreground"),
  border: text("border"),
  focus: text("focus"),
  link: text("link"),
  surface_shadow: text("surface_shadow"),
  overlay_shadow: text("overlay_shadow"),
  field_shadow: text("field_shadow"),
  muted_foreground: text("muted_foreground"),
  divider: text("divider"),
  glass_background: text("glass_background"),
  glass_border: text("glass_border"),
  glass_highlight: text("glass_highlight"),
  is_active: integer("is_active"),
  sort_order: integer("sort_order"),
});

// Only 1 row per user — indexes not needed.
export const user = sqliteTable("user", {
  id: text("id").primaryKey(),
  name: text("name"),
  email: text("email"),
  email_verified: integer("email_verified"),
  image: text("image"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  locale: text("locale"),
  global_theme_id: text("global_theme_id"),
  is_blur: integer("is_blur"),
  font_family: text("font_family"),
  follow_device_theme: integer("follow_device_theme"),
  role: text("role"),
});

export const drizzleSchema = {
  attachment,
  block,
  font_family,
  font_variant,
  member,
  organization,
  page,
  page_organization,
  page_version,
  session,
  themes,
  user,
};

export const AppSchema = new DrizzleAppSchema(drizzleSchema);

export type Database = (typeof AppSchema)["types"];

/**
 * Type helper for the Drizzle database instance wrapped with PowerSync.
 */
export type PowerSyncDrizzleDB = PowerSyncSQLiteDatabase<typeof drizzleSchema>;

export const USER_DATA_TABLES = ["attachment", "block", "page"] as const;

export type Attachment = InferSelectModel<typeof attachment>;
export type AttachmentInsert = InferInsertModel<typeof attachment>;
export type AttachmentRecord = Attachment;
export type Block = InferSelectModel<typeof block>;
export type BlockInsert = InferInsertModel<typeof block>;
export type BlockRecord = Block;
export type FontFamily = InferSelectModel<typeof font_family>;
export type FontFamilyInsert = InferInsertModel<typeof font_family>;
export type FontFamilyRecord = FontFamily;
export type FontVariant = InferSelectModel<typeof font_variant>;
export type FontVariantInsert = InferInsertModel<typeof font_variant>;
export type FontVariantRecord = FontVariant;
export type Member = InferSelectModel<typeof member>;
export type MemberInsert = InferInsertModel<typeof member>;
export type MemberRecord = Member;
export type Organization = InferSelectModel<typeof organization>;
export type OrganizationInsert = InferInsertModel<typeof organization>;
export type OrganizationRecord = Organization;
export type Page = InferSelectModel<typeof page>;
export type PageInsert = InferInsertModel<typeof page>;
export type PageRecord = Page;
export type PageOrganization = InferSelectModel<typeof page_organization>;
export type PageOrganizationInsert = InferInsertModel<typeof page_organization>;
export type PageOrganizationRecord = PageOrganization;
export type PageVersion = InferSelectModel<typeof page_version>;
export type PageVersionInsert = InferInsertModel<typeof page_version>;
export type PageVersionRecord = PageVersion;
export type Session = InferSelectModel<typeof session>;
export type SessionInsert = InferInsertModel<typeof session>;
export type SessionRecord = Session;
export type Themes = InferSelectModel<typeof themes>;
export type ThemesInsert = InferInsertModel<typeof themes>;
export type ThemesRecord = Themes;
export type User = InferSelectModel<typeof user>;
export type UserInsert = InferInsertModel<typeof user>;
export type UserRecord = User;
